export default "__VITE_ASSET__17379a6f__"